var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:[
    _vm.nightMode ? 'theme-dark' : 'theme-light',
    'bg-theme-page-background text-theme-text-content min-h-screen font-sans' ]},[_c('div',{class:{ blur: _vm.hasBlurFilter }},[_c('AppHeader'),_c('RouterView'),_c('AppFooter')],1),_c('PortalTarget',{attrs:{"name":"modal","multiple":""},on:{"change":_vm.onPortalChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }